import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';
import { AlertSeverityEnum, GROUPPROVEEDORES, IGroupProveedoresPagingRes, UseMutationsParams } from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import { getUrlParamsFetch, handleAxiosError } from '@/shared';

const { get, post, put } = erpApi();

///* tanSctack query

export const useFetchGroupProveedores = ({
    page = 1,
    page_size = 10,
    nombre = ''
}: GetGroupProveedoresParams) => {
    return useQuery({
        queryKey: ['proveedores', page, nombre, page_size],
        queryFn: async () => {
            return getGroupProveedores({ page, nombre, page_size });
        },
    });
};

export const useGetGroupProovedores=(id:number)=>{
    return useQuery({
        queryKey: ['group-proveedores', id],
        queryFn: async () => {
            return getGroupProovedores(id);
        },
    });
};
export const useCreateGroupProovedores = ({
    navigate,
  
    enableRedirect = true,
    returnUrl,
  
    returnErrorUrl,
    enableErrorRedirect = false,
    customMessageErrorAlert,
  
    enableSuccessAlert = true,
    customSuccessMessage,
  }: UseMutationsParams) => {
    const queryClient = useQueryClient();
    const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
    const setAlert = useUiStore.getState().setAlert;
  
    return useMutation({
      mutationFn: createGroupProovedores,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['group-proveedores'] });
  
        enableRedirect && navigate && returnUrl && navigate(returnUrl);
  
        enableSuccessAlert &&
          setAlert &&
          setAlert(
            true,
            customSuccessMessage ?? 'Grupo de proveedor creado correctamente',
            AlertSeverityEnum.success
          );
      },
      onError: error => {
        enableErrorRedirect &&
          navigate &&
          returnUrl &&
          navigate(returnErrorUrl ?? (returnUrl || ''));
  
        handleAxiosError(error, customMessageErrorAlert);
      },
      onSettled: () => {
        setIsGlobalLoading(false);
      },
    });
  };

export const useUpdateGroupProovedores = ({
    navigate,
  
    enableRedirect = true,
    returnUrl,
  
    returnErrorUrl,
    enableErrorRedirect = false,
    customMessageErrorAlert,
  
    enableSuccessAlert = true,
    customSuccessMessage,
  }: UseMutationsParams) => {
    const queryClient = useQueryClient();
    const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
    const setAlert = useUiStore.getState().setAlert;
  
    return useMutation({
      mutationFn: updateGroupProovedores,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['group-proveedores'] });
        enableRedirect && navigate && returnUrl && navigate(returnUrl);
  
        enableSuccessAlert &&
          setAlert &&
          setAlert(
            true,
            customSuccessMessage ?? 'Grupo de proveedor actualizado correctamente',
            AlertSeverityEnum.success
          );
      },
      onError: error => {
        enableErrorRedirect &&
          navigate &&
          returnUrl &&
          navigate(returnErrorUrl ?? (returnUrl || ''));
  
        handleAxiosError(error, customMessageErrorAlert);
      },
      onSettled: () => {
        setIsGlobalLoading(false);
      },
    });
  };

//axios
export type GetGroupProveedoresParams={
    page?:number,
    page_size?:number,
    nombre?:string
}
export type CreateGroupProveedoresParams= Omit<GROUPPROVEEDORES,'id_grupo_proveedor'>;
export type UpdateGroupProveedoresParams={
    id:string,
    data:CreateGroupProveedoresParams
}

export const getGroupProveedores = async (params?: GetGroupProveedoresParams) => {
    const queryParams = getUrlParamsFetch({ ...params });    return get<IGroupProveedoresPagingRes>(
        `${urlBackend}api/v1/grupos-proveedores/?${queryParams}`,
        true
    );
};
export const getGroupProovedores = async (id:number) => {
    try{
        return await get<GROUPPROVEEDORES>(
        `${urlBackend}api/grupos-proveedores/${id}/`,
        true
    );
}
catch(error){
  return handleAxiosError(error);
}
 }

export const createGroupProovedores = async (data: CreateGroupProveedoresParams) => {
    const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
    setIsGlobalLoading(true);
  
    return post<GROUPPROVEEDORES>(`${urlBackend}api/v1/grupos-proveedores/`, data, true);
};

export const updateGroupProovedores = async ({ id, data }: UpdateGroupProveedoresParams) => {
    const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
    setIsGlobalLoading(true);
    return put<GROUPPROVEEDORES>(`${urlBackend}api/v1/grupos-proveedores/${id}/`, data, true);
}




